import type { FaireProductEntity } from "../../entity_types/product";

export const p_25yngxv6bu: FaireProductEntity = {
  token: "p_25yngxv6bu",
  type: "product",
  name: "Essentials: Black Salt + Coconut Candle  | 12 oz.",
  brandToken: "b_b19tidse3g",
  brandName: "BOTANICA",
  imageUrl:
    "https://cdn.faire.com/fastly/60e5d998901c1f978db6bb30cd245aabbbb2e7c86ffbe788bc2e331f4f94caee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a14f125ee014ffb5f7b54c3a62cdf37aba9d78d8766e6be20a7f25949af836eb.jpeg",
    "https://cdn.faire.com/fastly/82a61d97d0d93659b81699d547d88730a57337fb17b92b8923d195c7288daa4e.jpeg",
    "https://cdn.faire.com/fastly/6c2bc87f6162792d73e8bab57d810ce5cc1d4b4f18eafe3310ba8e18b8d52a9d.jpeg",
    "https://cdn.faire.com/fastly/21bdae58f3f10e40bf85b46708d4ad3e5db2395021513dedc4a61b7b90f08ff7.jpeg",
    "https://cdn.faire.com/fastly/7436ceb4e7acdba4b7ac65bef31ab2abf283736a73622dc4f576eec491a3ed5e.jpeg",
  ],
  priceDollars: 22,
  description:
    "The perfect escapist fragrance - Black Salt Coconut will switch your space into Out-of-Office mode. Notes of sea salts, driftwood & coconut combine to formulate this perpetual-vacation scented candle. The Botanica Essentials Candle Collection features pure essential oils, balanced with nuanced fragrance oils to create provocative and true-to-nature scents.\n\nFragrance Notes: Black Salt, Driftwood, Coconut\n\n• 100% Soy + Coconut Wax Candle | 100% Cotton Wick\n• 12 oz. | 70 Hour Burn Time",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:11.888Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
